module.exports = __webpack_public_path__ + "static/img/19.a0aa3c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/2/1/eng/19.png
// module id = P8Yj
// module chunks = 0